import React from 'react';
import { string, arrayOf } from 'prop-types';
import AmpHtml from 'components/AmpHtml';
import AmpFacebookEmbed from './AmpFacebookEmbed';
import AmpInstagramEmbed from './AmpInstagramEmbed';
import AmpRedditEmbed from './AmpRedditEmbed';
import AmpTwitterEmbed from './AmpTwitterEmbed';
import AmpVimeoEmbed from './AmpVimeoEmbed';
import AmpYoutubeEmbed from './AmpYoutubeEmbed';
import AmpCuralateEmbed from './AmpCuralateEmbed';
import AmpCerosEmbed from './AmpCerosEmbed';

export const EMBEDS = {
  facebook: AmpFacebookEmbed,
  instagram: AmpInstagramEmbed,
  reddit: AmpRedditEmbed,
  twitter: AmpTwitterEmbed,
  vimeo: AmpVimeoEmbed,
  youtube: AmpYoutubeEmbed,
  curalate: AmpCuralateEmbed,
  ceros: AmpCerosEmbed
};

function AmpThirdPartyEmbed({ provider, url, raw, options }) {
  const EmbedComponent = EMBEDS[provider];

  if (EmbedComponent !== undefined) {
    return <EmbedComponent url={url} raw={raw} options={options} />;
  }
  return <AmpHtml html={raw} />;
}

AmpThirdPartyEmbed.propTypes = {
  provider: string.isRequired,
  url: string,
  raw: string,
  options: arrayOf(string)
};

AmpThirdPartyEmbed.defaultProps = {
  options: [],
  url: undefined,
  raw: null
};

export default AmpThirdPartyEmbed;
